import React from "react"
import {Card} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { injectIntl, Link } from "gatsby-plugin-react-intl";

const CalloutCard = ({ intl, theme, content }) => (
    <div className={`callout-card`}>
        <Card className={theme}>
            <Link className={`button`} to={content.url}>
                <Card.Body>
                    <span className={`button-area`}><span className={`text`}>{content.label}</span> <FontAwesomeIcon icon="arrow-right" /></span>
                </Card.Body>
            </Link>
        </Card>
    </div>
)

export default injectIntl(CalloutCard)
